module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper-setting"
  }, [_c('div', {
    staticStyle: {
      "background": "#fff"
    }
  }, [_c('el-tabs', {
    staticStyle: {
      "padding": "20px"
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "获取Code",
      "name": "first"
    }
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "api-sub-content"
  }, [_c('p', {
    staticClass: "linep"
  }, [_vm._v("协议规范：")]), _vm._v(" "), _c('div', {
    staticClass: "simpleline"
  }, [_c('strong', [_vm._v("接口协议：")]), _c('span', {
    staticClass: "url"
  }, [_vm._v("HTTP POST JSON")])]), _vm._v(" "), _c('div', {
    staticClass: "simpleline"
  }, [_c('strong', [_vm._v("接口地址：")]), _c('span', {
    staticClass: "url"
  }, [_vm._v(_vm._s(_vm.site) + "api/getCode?name=上海***有限公司")])]), _vm._v(" "), _c('div', {
    staticClass: "simpleline"
  }, [_c('strong', [_vm._v("模型评分接口监控：")]), _c('span', {
    staticClass: "url"
  }, [_vm._v("暂无")])]), _vm._v(" "), _c('div', {
    staticClass: "simpleline"
  }, [_c('a', {
    staticClass: "api-test-tools",
    attrs: {
      "href": "/box/index/id/54",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("API测试工具")])]), _vm._v(" "), _c('div', {
    staticClass: "simpleTable"
  }, [_c('p', {
    staticClass: "linep"
  }, [_vm._v("请求参数说明：")]), _vm._v(" "), _c('table', {
    staticClass: "api-table",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "cellspacing": "0",
      "cellpadding": "0"
    }
  }, [_c('tbody', [_c('tr', {
    staticClass: "title"
  }, [_c('th', {
    attrs: {
      "width": "20"
    }
  }), _vm._v(" "), _c('th', {
    attrs: {
      "width": "80"
    }
  }, [_vm._v("字段名")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "60"
    }
  }, [_vm._v("类型")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "60"
    }
  }, [_vm._v("上级节点")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "60"
    }
  }, [_vm._v("是否必须")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "250"
    }
  }, [_vm._v("样例")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "200"
    }
  }, [_vm._v("说明")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "100"
    }
  }, [_vm._v("备注")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("appKey")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("String")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("root")]), _vm._v(" "), _c('td', [_vm._v("是")]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("应用标识")]), _vm._v(" "), _c('td', [_vm._v("由我们提供")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("serviceKey")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("String")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("root")]), _vm._v(" "), _c('td', [_vm._v("是")]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("服务标识")]), _vm._v(" "), _c('td', [_vm._v("由我们提供")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("userKey")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("String")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("root")]), _vm._v(" "), _c('td', [_vm._v("是")]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("用户标识")]), _vm._v(" "), _c('td', [_vm._v("由我们提供")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("modelVersion")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("String")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("root")]), _vm._v(" "), _c('td', [_vm._v("是")]), _vm._v(" "), _c('td', [_vm._v("v2.0")]), _vm._v(" "), _c('td', [_vm._v("模型版本号")]), _vm._v(" "), _c('td', [_vm._v("由我们提供")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("data")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("String")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("root")]), _vm._v(" "), _c('td', [_vm._v("是")]), _vm._v(" "), _c('td', [_vm._v("68ad38ca959ccfa5fb2360ab7a62a705")]), _vm._v(" "), _c('td', [_vm._v("数据主体，md5加密或json格式")]), _vm._v(" "), _c('td', [_vm._v("用户提供")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("dataType")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("String")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("root")]), _vm._v(" "), _c('td', [_vm._v("是")]), _vm._v(" "), _c('td', [_vm._v("idCard/jsonTex")]), _vm._v(" "), _c('td', [_vm._v("数据类型")]), _vm._v(" "), _c('td', [_vm._v("用户提供")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("encryptType")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("String")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("root")]), _vm._v(" "), _c('td', [_vm._v("是")]), _vm._v(" "), _c('td', [_vm._v("md5/none")]), _vm._v(" "), _c('td', [_vm._v("数据加密类型")]), _vm._v(" "), _c('td', [_vm._v("用户提供")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "simpleTable"
  }, [_c('p', {
    staticClass: "linep"
  }, [_vm._v("请求参数json案例：")]), _vm._v(" "), _c('div', {
    staticClass: "prediv"
  }, [_c('pre', [_vm._v("      {\n        \"appKey\": \"app_key\",\n        \"serviceKey\": \"service_key\",\n        \"userKey\":\"d57f07b02f71be9d\",\n        \"modelVersion\":\"v2.0\",\n        \"data\":\"68ad38ca959ccfa5fb2360ab7a62a705\",\n        \"dataType\":\"idCard\",\n        \"encryptType\":\"md5\"\n      }\n    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "simpleTable"
  }, [_c('p', {
    staticClass: "linep"
  }, [_vm._v("返回参数说明：")]), _vm._v(" "), _c('table', {
    staticClass: "api-table",
    attrs: {
      "border": "0",
      "cellspacing": "0",
      "cellpadding": "0"
    }
  }, [_c('tbody', [_c('tr', {
    staticClass: "title"
  }, [_c('th', {
    attrs: {
      "width": "20"
    }
  }), _vm._v(" "), _c('th', [_vm._v("参数名称")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("上下节点")]), _vm._v(" "), _c('th', [_vm._v("说明")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("status")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("Integer")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("-")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("响应状态码。0成功 1请求成功但没有获取到数据 100失败")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("resultCode")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("String")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("-")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v(" 结束码。详情请看下方码表")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("message")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("String")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("-")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("提示信息")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("currentTime")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("Date")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("-")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("响应返回时间戳")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("data")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("Map")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("-")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("响应数据集Map")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("score")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("Double")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("data")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("评分结果")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "simpleTable"
  }, [_c('p', {
    staticClass: "linep"
  }, [_vm._v("JSON返回示例：")]), _vm._v(" "), _c('div', {
    staticClass: "prediv"
  }, [_c('pre', [_vm._v("       /****成功示例**/\n      {\n        \"status\": 0,\n        \"resultCode\": \"match_data\",\n        \"message\": \"执行成功\",\n        \"currentTime\": 1521183348685,\n        \"data\": {\n            \"score\": \"0.9948\"\n        }\n      }\n\n       /****失败示例**/\n      {\n          \"status\": 100,\n          \"resultCode\": \"auth_error\",\n          \"message\": \"认证失败，鉴权未通过\",\n          \"currentTime\": 1495632574458,\n          \"data\": {\n          }\n      }")])])]), _vm._v(" "), _c('div', {
    staticClass: "simpleTable"
  }, [_c('p', {
    staticClass: "linep"
  }, [_vm._v("结束码表说明：")]), _vm._v(" "), _c('table', {
    staticClass: "api-table",
    attrs: {
      "border": "0",
      "cellspacing": "0",
      "cellpadding": "0"
    }
  }, [_c('tbody', [_c('tr', {
    staticClass: "title"
  }, [_c('th', {
    attrs: {
      "width": "20"
    }
  }), _vm._v(" "), _c('th', [_vm._v("结束码")]), _vm._v(" "), _c('th', [_vm._v("说明")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("match_data")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("执行成功")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("unmatch_data")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("执行成功,未匹配到数据")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("param_error")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("认证失败，参数错误")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("auth_error")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("认证失败，鉴权未通过")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("system_error")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("执行失败，系统内部错误")])])])])])])]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "获取专利",
      "name": "second"
    }
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "api-sub-content"
  }, [_c('p', {
    staticClass: "linep"
  }, [_vm._v("协议规范：")]), _vm._v(" "), _c('div', {
    staticClass: "simpleline"
  }, [_c('strong', [_vm._v("接口协议：")]), _c('span', {
    staticClass: "url"
  }, [_vm._v("HTTP POST JSON")])]), _vm._v(" "), _c('div', {
    staticClass: "simpleline"
  }, [_c('strong', [_vm._v("接口地址：")]), _c('span', {
    staticClass: "url"
  }, [_vm._v(_vm._s(_vm.site) + "api/patent?code=914201126****59011&key=23456789")])]), _vm._v(" "), _c('div', {
    staticClass: "simpleline"
  }, [_c('strong', [_vm._v("模型评分接口监控：")]), _c('span', {
    staticClass: "url"
  }, [_vm._v("暂无")])]), _vm._v(" "), _c('div', {
    staticClass: "simpleline"
  }, [_c('a', {
    staticClass: "api-test-tools",
    attrs: {
      "href": "/box/index/id/54",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("API测试工具")])]), _vm._v(" "), _c('div', {
    staticClass: "simpleTable"
  }, [_c('p', {
    staticClass: "linep"
  }, [_vm._v("请求参数说明：")]), _vm._v(" "), _c('table', {
    staticClass: "api-table",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "cellspacing": "0",
      "cellpadding": "0"
    }
  }, [_c('tbody', [_c('tr', {
    staticClass: "title"
  }, [_c('th', {
    attrs: {
      "width": "20"
    }
  }), _vm._v(" "), _c('th', {
    attrs: {
      "width": "80"
    }
  }, [_vm._v("字段名")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "60"
    }
  }, [_vm._v("类型")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "100"
    }
  }, [_vm._v("上级节点")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "60"
    }
  }, [_vm._v("是否必须")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "200"
    }
  }, [_vm._v("样例")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "200"
    }
  }, [_vm._v("说明")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "100"
    }
  }, [_vm._v("备注")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("appKey")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("String")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("root")]), _vm._v(" "), _c('td', [_vm._v("是")]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("应用标识")]), _vm._v(" "), _c('td', [_vm._v("由我们提供")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("serviceKey")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("String")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("root")]), _vm._v(" "), _c('td', [_vm._v("是")]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("服务标识")]), _vm._v(" "), _c('td', [_vm._v("由我们提供")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("userKey")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("String")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("root")]), _vm._v(" "), _c('td', [_vm._v("是")]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("用户标识")]), _vm._v(" "), _c('td', [_vm._v("由我们提供")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("data")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("String")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("root")]), _vm._v(" "), _c('td', [_vm._v("是")]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("数据主体，json格式")]), _vm._v(" "), _c('td', [_vm._v("用户提供")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("encryptType")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("String")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("root")]), _vm._v(" "), _c('td', [_vm._v("是")]), _vm._v(" "), _c('td', [_vm._v("md5/none")]), _vm._v(" "), _c('td', [_vm._v("数据加密类型")]), _vm._v(" "), _c('td', [_vm._v("用户提供")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "simpleTable"
  }, [_c('p', {
    staticClass: "linep"
  }, [_vm._v("请求参数json案例：")]), _vm._v(" "), _c('div', {
    staticClass: "prediv"
  }, [_c('pre', [_vm._v("{\n        \"appKey\":\"\",\n        \"serviceKey\":\"\",\n        \"userKey\":\"\",\n        \"data\":{\n            \"idCard\":\"060017c70edb8ae84bc7f38f723fac0d\",\n            \"phone\":\"db8ece6a58e87adf6bfb9da9719a9b31\",\n            \"name\":\"杨洋\",\n            \"type\":\"type\",\n            \"source\":\"source\"\n        },\n        \"encryptType\":\"md5\"\n    }\n    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "simpleTable"
  }, [_c('p', {
    staticClass: "linep"
  }, [_vm._v("返回参数说明：")]), _vm._v(" "), _c('table', {
    staticClass: "api-table",
    attrs: {
      "border": "0",
      "cellspacing": "0",
      "cellpadding": "0"
    }
  }, [_c('tbody', [_c('tr', {
    staticClass: "title"
  }, [_c('th', {
    attrs: {
      "width": "20"
    }
  }), _vm._v(" "), _c('th', [_vm._v("参数名称")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("上下节点")]), _vm._v(" "), _c('th', [_vm._v("说明")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("status")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("Integer")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("-")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("响应状态码。0成功 1请求成功但没有获取到数据 100失败")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("resultCode")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("String")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("-")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v(" 结束码")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("message")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("String")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("-")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("提示信息")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "simpleTable"
  }, [_c('p', {
    staticClass: "linep"
  }, [_vm._v("JSON返回示例：")]), _vm._v(" "), _c('div', {
    staticClass: "prediv"
  }, [_c('pre', [_vm._v("       /****成功示例**/\n\n            身份证姓名和手机号都匹配\n    {\n      \"status\": 0,\n      \"resultCode\": \"match_data\",\n      \"message\": \"执行成功\",\n      \"currentTime\": 1529982895143,\n      \"data\": {\n        \"result\": 0,\n        \"info\": \"三信息匹配成功\"\n      }\n    }\n\n    身份证和手机号匹配，姓名不匹配\n\n    {\n      \"status\": 0,\n      \"resultCode\": \"match_data\",\n      \"message\": \"执行成功\",\n      \"currentTime\": 1529982926409,\n      \"data\": {\n        \"result\": 101,\n        \"info\": \"手机匹配成功\"\n      }\n    }\n\n    身份证和姓名匹配，手机号不匹配\n\n    {\n      \"status\": 0,\n      \"resultCode\": \"match_data\",\n      \"message\": \"执行成功\",\n      \"currentTime\": 1529982945610,\n      \"data\": {\n        \"result\": 102,\n        \"info\": \"姓名匹配成功\"\n      }\n    }\n\n    能获取到数据，但是手机号和姓名都不匹配\n\n    {\n      \"status\": 0,\n      \"resultCode\": \"match_data\",\n      \"message\": \"执行成功\",\n      \"currentTime\": 1529982960265,\n      \"data\": {\n        \"result\": 103,\n        \"info\": \"信息不匹配\"\n      }\n    }\n\n       /****失败示例**/\n\n    {\n      \"status\": 0,\n      \"resultCode\": \"match_data\",\n      \"message\": \"执行成功\",\n      \"currentTime\": 1529982974899,\n      \"data\": {\n        \"result\": 100,\n        \"info\": \"没有查询到数据\"\n      }\n    }\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "simpleTable"
  }, [_c('p', {
    staticClass: "linep"
  }, [_vm._v("结束码表说明：")]), _vm._v(" "), _c('table', {
    staticClass: "api-table",
    attrs: {
      "border": "0",
      "cellspacing": "0",
      "cellpadding": "0"
    }
  }, [_c('tbody', [_c('tr', {
    staticClass: "title"
  }, [_c('th', {
    attrs: {
      "width": "20"
    }
  }), _vm._v(" "), _c('th', [_vm._v("结束码")]), _vm._v(" "), _c('th', [_vm._v("说明")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("match_data")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("执行成功")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("unmatch_data")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("执行成功,未匹配到数据")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("param_error")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("认证失败，参数错误")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("auth_error")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("认证失败，鉴权未通过")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("system_error")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("执行失败，系统内部错误")])])])])])])]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "获取著作权",
      "name": "third"
    }
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "api-sub-content"
  }, [_c('p', {
    staticClass: "linep"
  }, [_vm._v("协议规范：")]), _vm._v(" "), _c('div', {
    staticClass: "simpleline"
  }, [_c('strong', [_vm._v("接口协议：")]), _c('span', {
    staticClass: "url"
  }, [_vm._v("HTTP POST JSON")])]), _vm._v(" "), _c('div', {
    staticClass: "simpleline"
  }, [_c('strong', [_vm._v("接口地址：")]), _c('span', {
    staticClass: "url"
  }, [_vm._v(_vm._s(_vm.site) + "api/info?code=914201126667559011&key=12345")])]), _vm._v(" "), _c('div', {
    staticClass: "simpleline"
  }, [_c('strong', [_vm._v("模型评分接口监控：")]), _c('span', {
    staticClass: "url"
  }, [_vm._v("暂无")])]), _vm._v(" "), _c('div', {
    staticClass: "simpleline"
  }, [_c('a', {
    staticClass: "api-test-tools",
    attrs: {
      "href": "/box/index/id/54",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("API测试工具")])]), _vm._v(" "), _c('div', {
    staticClass: "simpleTable"
  }, [_c('p', {
    staticClass: "linep"
  }, [_vm._v("请求参数说明：")]), _vm._v(" "), _c('table', {
    staticClass: "api-table",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "cellspacing": "0",
      "cellpadding": "0"
    }
  }, [_c('tbody', [_c('tr', {
    staticClass: "title"
  }, [_c('th', {
    attrs: {
      "width": "20"
    }
  }), _vm._v(" "), _c('th', {
    attrs: {
      "width": "80"
    }
  }, [_vm._v("字段名")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "60"
    }
  }, [_vm._v("类型")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "100"
    }
  }, [_vm._v("上级节点")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "60"
    }
  }, [_vm._v("是否必须")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "200"
    }
  }, [_vm._v("样例")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "200"
    }
  }, [_vm._v("说明")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "100"
    }
  }, [_vm._v("备注")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("appKey")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("String")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("root")]), _vm._v(" "), _c('td', [_vm._v("是")]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("应用标识")]), _vm._v(" "), _c('td', [_vm._v("由我们提供")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("serviceKey")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("String")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("root")]), _vm._v(" "), _c('td', [_vm._v("是")]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("服务标识")]), _vm._v(" "), _c('td', [_vm._v("由我们提供")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("userKey")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("String")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("root")]), _vm._v(" "), _c('td', [_vm._v("是")]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("用户标识")]), _vm._v(" "), _c('td', [_vm._v("由我们提供")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("data")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("String")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("root")]), _vm._v(" "), _c('td', [_vm._v("是")]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("数据主体，json格式")]), _vm._v(" "), _c('td', [_vm._v("用户提供")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("encryptType")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("String")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("root")]), _vm._v(" "), _c('td', [_vm._v("是")]), _vm._v(" "), _c('td', [_vm._v("md5/none")]), _vm._v(" "), _c('td', [_vm._v("数据加密类型")]), _vm._v(" "), _c('td', [_vm._v("用户提供")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "simpleTable"
  }, [_c('p', {
    staticClass: "linep"
  }, [_vm._v("请求参数json案例：")]), _vm._v(" "), _c('div', {
    staticClass: "prediv"
  }, [_c('pre', [_vm._v("{\n        \"appKey\":\"\",\n        \"serviceKey\":\"\",\n        \"userKey\":\"\",\n        \"data\":{\n            \"idCard\":\"060017c70edb8ae84bc7f38f723fac0d\",\n            \"phone\":\"db8ece6a58e87adf6bfb9da9719a9b31\",\n            \"name\":\"杨洋\",\n            \"type\":\"type\",\n            \"source\":\"source\"\n        },\n        \"encryptType\":\"md5\"\n    }\n    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "simpleTable"
  }, [_c('p', {
    staticClass: "linep"
  }, [_vm._v("返回参数说明：")]), _vm._v(" "), _c('table', {
    staticClass: "api-table",
    attrs: {
      "border": "0",
      "cellspacing": "0",
      "cellpadding": "0"
    }
  }, [_c('tbody', [_c('tr', {
    staticClass: "title"
  }, [_c('th', {
    attrs: {
      "width": "20"
    }
  }), _vm._v(" "), _c('th', [_vm._v("参数名称")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("上下节点")]), _vm._v(" "), _c('th', [_vm._v("说明")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("status")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("Integer")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("-")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("响应状态码。0成功 1请求成功但没有获取到数据 100失败")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("resultCode")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("String")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("-")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v(" 结束码")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("message")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("String")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("-")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("提示信息")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "simpleTable"
  }, [_c('p', {
    staticClass: "linep"
  }, [_vm._v("JSON返回示例：")]), _vm._v(" "), _c('div', {
    staticClass: "prediv"
  }, [_c('pre', [_vm._v("       /****成功示例**/\n\n            身份证姓名和手机号都匹配\n    {\n      \"status\": 0,\n      \"resultCode\": \"match_data\",\n      \"message\": \"执行成功\",\n      \"currentTime\": 1529982895143,\n      \"data\": {\n        \"result\": 0,\n        \"info\": \"三信息匹配成功\"\n      }\n    }\n\n    身份证和手机号匹配，姓名不匹配\n\n    {\n      \"status\": 0,\n      \"resultCode\": \"match_data\",\n      \"message\": \"执行成功\",\n      \"currentTime\": 1529982926409,\n      \"data\": {\n        \"result\": 101,\n        \"info\": \"手机匹配成功\"\n      }\n    }\n\n    身份证和姓名匹配，手机号不匹配\n\n    {\n      \"status\": 0,\n      \"resultCode\": \"match_data\",\n      \"message\": \"执行成功\",\n      \"currentTime\": 1529982945610,\n      \"data\": {\n        \"result\": 102,\n        \"info\": \"姓名匹配成功\"\n      }\n    }\n\n    能获取到数据，但是手机号和姓名都不匹配\n\n    {\n      \"status\": 0,\n      \"resultCode\": \"match_data\",\n      \"message\": \"执行成功\",\n      \"currentTime\": 1529982960265,\n      \"data\": {\n        \"result\": 103,\n        \"info\": \"信息不匹配\"\n      }\n    }\n\n       /****失败示例**/\n\n    {\n      \"status\": 0,\n      \"resultCode\": \"match_data\",\n      \"message\": \"执行成功\",\n      \"currentTime\": 1529982974899,\n      \"data\": {\n        \"result\": 100,\n        \"info\": \"没有查询到数据\"\n      }\n    }\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "simpleTable"
  }, [_c('p', {
    staticClass: "linep"
  }, [_vm._v("结束码表说明：")]), _vm._v(" "), _c('table', {
    staticClass: "api-table",
    attrs: {
      "border": "0",
      "cellspacing": "0",
      "cellpadding": "0"
    }
  }, [_c('tbody', [_c('tr', {
    staticClass: "title"
  }, [_c('th', {
    attrs: {
      "width": "20"
    }
  }), _vm._v(" "), _c('th', [_vm._v("结束码")]), _vm._v(" "), _c('th', [_vm._v("说明")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("match_data")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("执行成功")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("unmatch_data")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("执行成功,未匹配到数据")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("param_error")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("认证失败，参数错误")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("auth_error")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("认证失败，鉴权未通过")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("system_error")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("执行失败，系统内部错误")])])])])])])]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "获取股东",
      "name": "fourth"
    }
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "api-sub-content"
  }, [_c('p', {
    staticClass: "linep"
  }, [_vm._v("协议规范：")]), _vm._v(" "), _c('div', {
    staticClass: "simpleline"
  }, [_c('strong', [_vm._v("接口协议：")]), _c('span', {
    staticClass: "url"
  }, [_vm._v("HTTP POST JSON")])]), _vm._v(" "), _c('div', {
    staticClass: "simpleline"
  }, [_c('strong', [_vm._v("接口地址：")]), _c('span', {
    staticClass: "url"
  }, [_vm._v(_vm._s(_vm.site) + "api/holder?code=914201126667559011&key=12345")])]), _vm._v(" "), _c('div', {
    staticClass: "simpleline"
  }, [_c('strong', [_vm._v("模型评分接口监控：")]), _c('span', {
    staticClass: "url"
  }, [_vm._v("暂无")])]), _vm._v(" "), _c('div', {
    staticClass: "simpleline"
  }, [_c('a', {
    staticClass: "api-test-tools",
    attrs: {
      "href": "/box/index/id/54",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("API测试工具")])]), _vm._v(" "), _c('div', {
    staticClass: "simpleTable"
  }, [_c('p', {
    staticClass: "linep"
  }, [_vm._v("请求参数说明：")]), _vm._v(" "), _c('table', {
    staticClass: "api-table",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "cellspacing": "0",
      "cellpadding": "0"
    }
  }, [_c('tbody', [_c('tr', {
    staticClass: "title"
  }, [_c('th', {
    attrs: {
      "width": "20"
    }
  }), _vm._v(" "), _c('th', {
    attrs: {
      "width": "80"
    }
  }, [_vm._v("字段名")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "60"
    }
  }, [_vm._v("类型")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "100"
    }
  }, [_vm._v("上级节点")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "60"
    }
  }, [_vm._v("是否必须")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "200"
    }
  }, [_vm._v("样例")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "200"
    }
  }, [_vm._v("说明")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "100"
    }
  }, [_vm._v("备注")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("appKey")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("String")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("root")]), _vm._v(" "), _c('td', [_vm._v("是")]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("应用标识")]), _vm._v(" "), _c('td', [_vm._v("由我们提供")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("serviceKey")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("String")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("root")]), _vm._v(" "), _c('td', [_vm._v("是")]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("服务标识")]), _vm._v(" "), _c('td', [_vm._v("由我们提供")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("userKey")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("String")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("root")]), _vm._v(" "), _c('td', [_vm._v("是")]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("用户标识")]), _vm._v(" "), _c('td', [_vm._v("由我们提供")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("data")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("String")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("root")]), _vm._v(" "), _c('td', [_vm._v("是")]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("数据主体，json格式")]), _vm._v(" "), _c('td', [_vm._v("用户提供")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("encryptType")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("String")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("root")]), _vm._v(" "), _c('td', [_vm._v("是")]), _vm._v(" "), _c('td', [_vm._v("md5/none")]), _vm._v(" "), _c('td', [_vm._v("数据加密类型")]), _vm._v(" "), _c('td', [_vm._v("用户提供")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "simpleTable"
  }, [_c('p', {
    staticClass: "linep"
  }, [_vm._v("请求参数json案例：")]), _vm._v(" "), _c('div', {
    staticClass: "prediv"
  }, [_c('pre', [_vm._v("{\n        \"appKey\":\"\",\n        \"serviceKey\":\"\",\n        \"userKey\":\"\",\n        \"data\":{\n            \"idCard\":\"060017c70edb8ae84bc7f38f723fac0d\",\n            \"phone\":\"db8ece6a58e87adf6bfb9da9719a9b31\",\n            \"name\":\"杨洋\",\n            \"type\":\"type\",\n            \"source\":\"source\"\n        },\n        \"encryptType\":\"md5\"\n    }\n    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "simpleTable"
  }, [_c('p', {
    staticClass: "linep"
  }, [_vm._v("返回参数说明：")]), _vm._v(" "), _c('table', {
    staticClass: "api-table",
    attrs: {
      "border": "0",
      "cellspacing": "0",
      "cellpadding": "0"
    }
  }, [_c('tbody', [_c('tr', {
    staticClass: "title"
  }, [_c('th', {
    attrs: {
      "width": "20"
    }
  }), _vm._v(" "), _c('th', [_vm._v("参数名称")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("上下节点")]), _vm._v(" "), _c('th', [_vm._v("说明")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("status")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("Integer")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("-")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("响应状态码。0成功 1请求成功但没有获取到数据 100失败")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("resultCode")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("String")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("-")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v(" 结束码")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("message")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("String")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("-")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("提示信息")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "simpleTable"
  }, [_c('p', {
    staticClass: "linep"
  }, [_vm._v("JSON返回示例：")]), _vm._v(" "), _c('div', {
    staticClass: "prediv"
  }, [_c('pre', [_vm._v("       /****成功示例**/\n\n            身份证姓名和手机号都匹配\n    {\n      \"status\": 0,\n      \"resultCode\": \"match_data\",\n      \"message\": \"执行成功\",\n      \"currentTime\": 1529982895143,\n      \"data\": {\n        \"result\": 0,\n        \"info\": \"三信息匹配成功\"\n      }\n    }\n\n    身份证和手机号匹配，姓名不匹配\n\n    {\n      \"status\": 0,\n      \"resultCode\": \"match_data\",\n      \"message\": \"执行成功\",\n      \"currentTime\": 1529982926409,\n      \"data\": {\n        \"result\": 101,\n        \"info\": \"手机匹配成功\"\n      }\n    }\n\n    身份证和姓名匹配，手机号不匹配\n\n    {\n      \"status\": 0,\n      \"resultCode\": \"match_data\",\n      \"message\": \"执行成功\",\n      \"currentTime\": 1529982945610,\n      \"data\": {\n        \"result\": 102,\n        \"info\": \"姓名匹配成功\"\n      }\n    }\n\n    能获取到数据，但是手机号和姓名都不匹配\n\n    {\n      \"status\": 0,\n      \"resultCode\": \"match_data\",\n      \"message\": \"执行成功\",\n      \"currentTime\": 1529982960265,\n      \"data\": {\n        \"result\": 103,\n        \"info\": \"信息不匹配\"\n      }\n    }\n\n       /****失败示例**/\n\n    {\n      \"status\": 0,\n      \"resultCode\": \"match_data\",\n      \"message\": \"执行成功\",\n      \"currentTime\": 1529982974899,\n      \"data\": {\n        \"result\": 100,\n        \"info\": \"没有查询到数据\"\n      }\n    }\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "simpleTable"
  }, [_c('p', {
    staticClass: "linep"
  }, [_vm._v("结束码表说明：")]), _vm._v(" "), _c('table', {
    staticClass: "api-table",
    attrs: {
      "border": "0",
      "cellspacing": "0",
      "cellpadding": "0"
    }
  }, [_c('tbody', [_c('tr', {
    staticClass: "title"
  }, [_c('th', {
    attrs: {
      "width": "20"
    }
  }), _vm._v(" "), _c('th', [_vm._v("结束码")]), _vm._v(" "), _c('th', [_vm._v("说明")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("match_data")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("执行成功")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("unmatch_data")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("执行成功,未匹配到数据")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("param_error")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("认证失败，参数错误")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("auth_error")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("认证失败，鉴权未通过")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("system_error")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("执行失败，系统内部错误")])])])])])])]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "获取高管",
      "name": "fifth"
    }
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "api-sub-content"
  }, [_c('p', {
    staticClass: "linep"
  }, [_vm._v("协议规范：")]), _vm._v(" "), _c('div', {
    staticClass: "simpleline"
  }, [_c('strong', [_vm._v("接口协议：")]), _c('span', {
    staticClass: "url"
  }, [_vm._v("HTTP POST JSON")])]), _vm._v(" "), _c('div', {
    staticClass: "simpleline"
  }, [_c('strong', [_vm._v("接口地址：")]), _c('span', {
    staticClass: "url"
  }, [_vm._v(_vm._s(_vm.site) + "api/staff?code=914201126667559011&key=12345")])]), _vm._v(" "), _c('div', {
    staticClass: "simpleline"
  }, [_c('strong', [_vm._v("模型评分接口监控：")]), _c('span', {
    staticClass: "url"
  }, [_vm._v("暂无")])]), _vm._v(" "), _c('div', {
    staticClass: "simpleline"
  }, [_c('a', {
    staticClass: "api-test-tools",
    attrs: {
      "href": "/box/index/id/54",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("API测试工具")])]), _vm._v(" "), _c('div', {
    staticClass: "simpleTable"
  }, [_c('p', {
    staticClass: "linep"
  }, [_vm._v("请求参数说明：")]), _vm._v(" "), _c('table', {
    staticClass: "api-table",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "cellspacing": "0",
      "cellpadding": "0"
    }
  }, [_c('tbody', [_c('tr', {
    staticClass: "title"
  }, [_c('th', {
    attrs: {
      "width": "20"
    }
  }), _vm._v(" "), _c('th', {
    attrs: {
      "width": "80"
    }
  }, [_vm._v("字段名")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "60"
    }
  }, [_vm._v("类型")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "100"
    }
  }, [_vm._v("上级节点")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "60"
    }
  }, [_vm._v("是否必须")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "200"
    }
  }, [_vm._v("样例")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "200"
    }
  }, [_vm._v("说明")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "100"
    }
  }, [_vm._v("备注")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("appKey")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("String")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("root")]), _vm._v(" "), _c('td', [_vm._v("是")]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("应用标识")]), _vm._v(" "), _c('td', [_vm._v("由我们提供")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("serviceKey")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("String")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("root")]), _vm._v(" "), _c('td', [_vm._v("是")]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("服务标识")]), _vm._v(" "), _c('td', [_vm._v("由我们提供")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("userKey")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("String")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("root")]), _vm._v(" "), _c('td', [_vm._v("是")]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("用户标识")]), _vm._v(" "), _c('td', [_vm._v("由我们提供")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("data")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("String")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("root")]), _vm._v(" "), _c('td', [_vm._v("是")]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("数据主体，json格式")]), _vm._v(" "), _c('td', [_vm._v("用户提供")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("encryptType")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("String")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("root")]), _vm._v(" "), _c('td', [_vm._v("是")]), _vm._v(" "), _c('td', [_vm._v("md5/none")]), _vm._v(" "), _c('td', [_vm._v("数据加密类型")]), _vm._v(" "), _c('td', [_vm._v("用户提供")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "simpleTable"
  }, [_c('p', {
    staticClass: "linep"
  }, [_vm._v("请求参数json案例：")]), _vm._v(" "), _c('div', {
    staticClass: "prediv"
  }, [_c('pre', [_vm._v("{\n        \"appKey\":\"\",\n        \"serviceKey\":\"\",\n        \"userKey\":\"\",\n        \"data\":{\n            \"idCard\":\"060017c70edb8ae84bc7f38f723fac0d\",\n            \"phone\":\"db8ece6a58e87adf6bfb9da9719a9b31\",\n            \"name\":\"杨洋\",\n            \"type\":\"type\",\n            \"source\":\"source\"\n        },\n        \"encryptType\":\"md5\"\n    }\n    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "simpleTable"
  }, [_c('p', {
    staticClass: "linep"
  }, [_vm._v("返回参数说明：")]), _vm._v(" "), _c('table', {
    staticClass: "api-table",
    attrs: {
      "border": "0",
      "cellspacing": "0",
      "cellpadding": "0"
    }
  }, [_c('tbody', [_c('tr', {
    staticClass: "title"
  }, [_c('th', {
    attrs: {
      "width": "20"
    }
  }), _vm._v(" "), _c('th', [_vm._v("参数名称")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("上下节点")]), _vm._v(" "), _c('th', [_vm._v("说明")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("status")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("Integer")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("-")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("响应状态码。0成功 1请求成功但没有获取到数据 100失败")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("resultCode")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("String")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("-")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v(" 结束码")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("message")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("String")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("-")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("提示信息")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "simpleTable"
  }, [_c('p', {
    staticClass: "linep"
  }, [_vm._v("JSON返回示例：")]), _vm._v(" "), _c('div', {
    staticClass: "prediv"
  }, [_c('pre', [_vm._v("       /****成功示例**/\n\n            身份证姓名和手机号都匹配\n    {\n      \"status\": 0,\n      \"resultCode\": \"match_data\",\n      \"message\": \"执行成功\",\n      \"currentTime\": 1529982895143,\n      \"data\": {\n        \"result\": 0,\n        \"info\": \"三信息匹配成功\"\n      }\n    }\n\n    身份证和手机号匹配，姓名不匹配\n\n    {\n      \"status\": 0,\n      \"resultCode\": \"match_data\",\n      \"message\": \"执行成功\",\n      \"currentTime\": 1529982926409,\n      \"data\": {\n        \"result\": 101,\n        \"info\": \"手机匹配成功\"\n      }\n    }\n\n    身份证和姓名匹配，手机号不匹配\n\n    {\n      \"status\": 0,\n      \"resultCode\": \"match_data\",\n      \"message\": \"执行成功\",\n      \"currentTime\": 1529982945610,\n      \"data\": {\n        \"result\": 102,\n        \"info\": \"姓名匹配成功\"\n      }\n    }\n\n    能获取到数据，但是手机号和姓名都不匹配\n\n    {\n      \"status\": 0,\n      \"resultCode\": \"match_data\",\n      \"message\": \"执行成功\",\n      \"currentTime\": 1529982960265,\n      \"data\": {\n        \"result\": 103,\n        \"info\": \"信息不匹配\"\n      }\n    }\n\n       /****失败示例**/\n\n    {\n      \"status\": 0,\n      \"resultCode\": \"match_data\",\n      \"message\": \"执行成功\",\n      \"currentTime\": 1529982974899,\n      \"data\": {\n        \"result\": 100,\n        \"info\": \"没有查询到数据\"\n      }\n    }\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "simpleTable"
  }, [_c('p', {
    staticClass: "linep"
  }, [_vm._v("结束码表说明：")]), _vm._v(" "), _c('table', {
    staticClass: "api-table",
    attrs: {
      "border": "0",
      "cellspacing": "0",
      "cellpadding": "0"
    }
  }, [_c('tbody', [_c('tr', {
    staticClass: "title"
  }, [_c('th', {
    attrs: {
      "width": "20"
    }
  }), _vm._v(" "), _c('th', [_vm._v("结束码")]), _vm._v(" "), _c('th', [_vm._v("说明")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("match_data")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("执行成功")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("unmatch_data")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("执行成功,未匹配到数据")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("param_error")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("认证失败，参数错误")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("auth_error")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("认证失败，鉴权未通过")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("system_error")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("执行失败，系统内部错误")])])])])])])]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "招投标信息",
      "name": "sixth"
    }
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "api-sub-content"
  }, [_c('p', {
    staticClass: "linep"
  }, [_vm._v("协议规范：")]), _vm._v(" "), _c('div', {
    staticClass: "simpleline"
  }, [_c('strong', [_vm._v("接口协议：")]), _c('span', {
    staticClass: "url"
  }, [_vm._v("HTTP POST JSON")])]), _vm._v(" "), _c('div', {
    staticClass: "simpleline"
  }, [_c('strong', [_vm._v("接口地址：")]), _c('span', {
    staticClass: "url"
  }, [_vm._v(_vm._s(_vm.site) + "api/info?code=914201126667559011&key=12345")])]), _vm._v(" "), _c('div', {
    staticClass: "simpleline"
  }, [_c('strong', [_vm._v("模型评分接口监控：")]), _c('span', {
    staticClass: "url"
  }, [_vm._v("暂无")])]), _vm._v(" "), _c('div', {
    staticClass: "simpleline"
  }, [_c('a', {
    staticClass: "api-test-tools",
    attrs: {
      "href": "/box/index/id/54",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("API测试工具")])]), _vm._v(" "), _c('div', {
    staticClass: "simpleTable"
  }, [_c('p', {
    staticClass: "linep"
  }, [_vm._v("请求参数说明：")]), _vm._v(" "), _c('table', {
    staticClass: "api-table",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "cellspacing": "0",
      "cellpadding": "0"
    }
  }, [_c('tbody', [_c('tr', {
    staticClass: "title"
  }, [_c('th', {
    attrs: {
      "width": "20"
    }
  }), _vm._v(" "), _c('th', {
    attrs: {
      "width": "80"
    }
  }, [_vm._v("字段名")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "60"
    }
  }, [_vm._v("类型")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "100"
    }
  }, [_vm._v("上级节点")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "60"
    }
  }, [_vm._v("是否必须")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "200"
    }
  }, [_vm._v("样例")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "200"
    }
  }, [_vm._v("说明")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "100"
    }
  }, [_vm._v("备注")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("appKey")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("String")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("root")]), _vm._v(" "), _c('td', [_vm._v("是")]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("应用标识")]), _vm._v(" "), _c('td', [_vm._v("由我们提供")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("serviceKey")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("String")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("root")]), _vm._v(" "), _c('td', [_vm._v("是")]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("服务标识")]), _vm._v(" "), _c('td', [_vm._v("由我们提供")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("userKey")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("String")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("root")]), _vm._v(" "), _c('td', [_vm._v("是")]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("用户标识")]), _vm._v(" "), _c('td', [_vm._v("由我们提供")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("data")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("String")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("root")]), _vm._v(" "), _c('td', [_vm._v("是")]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("数据主体，json格式")]), _vm._v(" "), _c('td', [_vm._v("用户提供")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("encryptType")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("String")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("root")]), _vm._v(" "), _c('td', [_vm._v("是")]), _vm._v(" "), _c('td', [_vm._v("md5/none")]), _vm._v(" "), _c('td', [_vm._v("数据加密类型")]), _vm._v(" "), _c('td', [_vm._v("用户提供")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "simpleTable"
  }, [_c('p', {
    staticClass: "linep"
  }, [_vm._v("请求参数json案例：")]), _vm._v(" "), _c('div', {
    staticClass: "prediv"
  }, [_c('pre', [_vm._v("{\n        \"appKey\":\"\",\n        \"serviceKey\":\"\",\n        \"userKey\":\"\",\n        \"data\":{\n            \"idCard\":\"060017c70edb8ae84bc7f38f723fac0d\",\n            \"phone\":\"db8ece6a58e87adf6bfb9da9719a9b31\",\n            \"name\":\"杨洋\",\n            \"type\":\"type\",\n            \"source\":\"source\"\n        },\n        \"encryptType\":\"md5\"\n    }\n    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "simpleTable"
  }, [_c('p', {
    staticClass: "linep"
  }, [_vm._v("返回参数说明：")]), _vm._v(" "), _c('table', {
    staticClass: "api-table",
    attrs: {
      "border": "0",
      "cellspacing": "0",
      "cellpadding": "0"
    }
  }, [_c('tbody', [_c('tr', {
    staticClass: "title"
  }, [_c('th', {
    attrs: {
      "width": "20"
    }
  }), _vm._v(" "), _c('th', [_vm._v("参数名称")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("上下节点")]), _vm._v(" "), _c('th', [_vm._v("说明")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("status")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("Integer")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("-")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("响应状态码。0成功 1请求成功但没有获取到数据 100失败")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("resultCode")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("String")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("-")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v(" 结束码")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("message")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("String")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("-")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("提示信息")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "simpleTable"
  }, [_c('p', {
    staticClass: "linep"
  }, [_vm._v("JSON返回示例：")]), _vm._v(" "), _c('div', {
    staticClass: "prediv"
  }, [_c('pre', [_vm._v("       /****成功示例**/\n\n            身份证姓名和手机号都匹配\n    {\n      \"status\": 0,\n      \"resultCode\": \"match_data\",\n      \"message\": \"执行成功\",\n      \"currentTime\": 1529982895143,\n      \"data\": {\n        \"result\": 0,\n        \"info\": \"三信息匹配成功\"\n      }\n    }\n\n    身份证和手机号匹配，姓名不匹配\n\n    {\n      \"status\": 0,\n      \"resultCode\": \"match_data\",\n      \"message\": \"执行成功\",\n      \"currentTime\": 1529982926409,\n      \"data\": {\n        \"result\": 101,\n        \"info\": \"手机匹配成功\"\n      }\n    }\n\n    身份证和姓名匹配，手机号不匹配\n\n    {\n      \"status\": 0,\n      \"resultCode\": \"match_data\",\n      \"message\": \"执行成功\",\n      \"currentTime\": 1529982945610,\n      \"data\": {\n        \"result\": 102,\n        \"info\": \"姓名匹配成功\"\n      }\n    }\n\n    能获取到数据，但是手机号和姓名都不匹配\n\n    {\n      \"status\": 0,\n      \"resultCode\": \"match_data\",\n      \"message\": \"执行成功\",\n      \"currentTime\": 1529982960265,\n      \"data\": {\n        \"result\": 103,\n        \"info\": \"信息不匹配\"\n      }\n    }\n\n       /****失败示例**/\n\n    {\n      \"status\": 0,\n      \"resultCode\": \"match_data\",\n      \"message\": \"执行成功\",\n      \"currentTime\": 1529982974899,\n      \"data\": {\n        \"result\": 100,\n        \"info\": \"没有查询到数据\"\n      }\n    }\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "simpleTable"
  }, [_c('p', {
    staticClass: "linep"
  }, [_vm._v("结束码表说明：")]), _vm._v(" "), _c('table', {
    staticClass: "api-table",
    attrs: {
      "border": "0",
      "cellspacing": "0",
      "cellpadding": "0"
    }
  }, [_c('tbody', [_c('tr', {
    staticClass: "title"
  }, [_c('th', {
    attrs: {
      "width": "20"
    }
  }), _vm._v(" "), _c('th', [_vm._v("结束码")]), _vm._v(" "), _c('th', [_vm._v("说明")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("match_data")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("执行成功")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("unmatch_data")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("执行成功,未匹配到数据")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("param_error")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("认证失败，参数错误")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("auth_error")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("认证失败，鉴权未通过")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("system_error")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("执行失败，系统内部错误")])])])])])])]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "产业链",
      "name": "seven"
    }
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "api-sub-content"
  }, [_c('p', {
    staticClass: "linep"
  }, [_vm._v("协议规范：")]), _vm._v(" "), _c('div', {
    staticClass: "simpleline"
  }, [_c('strong', [_vm._v("接口协议：")]), _c('span', {
    staticClass: "url"
  }, [_vm._v("HTTP POST JSON")])]), _vm._v(" "), _c('div', {
    staticClass: "simpleline"
  }, [_c('strong', [_vm._v("接口地址：")]), _c('span', {
    staticClass: "url"
  }, [_vm._v(_vm._s(_vm.site) + "api/info?code=914201126667559011&key=12345")])]), _vm._v(" "), _c('div', {
    staticClass: "simpleline"
  }, [_c('strong', [_vm._v("模型评分接口监控：")]), _c('span', {
    staticClass: "url"
  }, [_vm._v("暂无")])]), _vm._v(" "), _c('div', {
    staticClass: "simpleline"
  }, [_c('a', {
    staticClass: "api-test-tools",
    attrs: {
      "href": "/box/index/id/54",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("API测试工具")])]), _vm._v(" "), _c('div', {
    staticClass: "simpleTable"
  }, [_c('p', {
    staticClass: "linep"
  }, [_vm._v("请求参数说明：")]), _vm._v(" "), _c('table', {
    staticClass: "api-table",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "cellspacing": "0",
      "cellpadding": "0"
    }
  }, [_c('tbody', [_c('tr', {
    staticClass: "title"
  }, [_c('th', {
    attrs: {
      "width": "20"
    }
  }), _vm._v(" "), _c('th', {
    attrs: {
      "width": "80"
    }
  }, [_vm._v("字段名")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "60"
    }
  }, [_vm._v("类型")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "100"
    }
  }, [_vm._v("上级节点")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "60"
    }
  }, [_vm._v("是否必须")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "200"
    }
  }, [_vm._v("样例")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "200"
    }
  }, [_vm._v("说明")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "100"
    }
  }, [_vm._v("备注")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("appKey")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("String")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("root")]), _vm._v(" "), _c('td', [_vm._v("是")]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("应用标识")]), _vm._v(" "), _c('td', [_vm._v("由我们提供")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("serviceKey")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("String")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("root")]), _vm._v(" "), _c('td', [_vm._v("是")]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("服务标识")]), _vm._v(" "), _c('td', [_vm._v("由我们提供")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("userKey")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("String")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("root")]), _vm._v(" "), _c('td', [_vm._v("是")]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("用户标识")]), _vm._v(" "), _c('td', [_vm._v("由我们提供")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("data")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("String")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("root")]), _vm._v(" "), _c('td', [_vm._v("是")]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("数据主体，json格式")]), _vm._v(" "), _c('td', [_vm._v("用户提供")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("encryptType")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("String")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("root")]), _vm._v(" "), _c('td', [_vm._v("是")]), _vm._v(" "), _c('td', [_vm._v("md5/none")]), _vm._v(" "), _c('td', [_vm._v("数据加密类型")]), _vm._v(" "), _c('td', [_vm._v("用户提供")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "simpleTable"
  }, [_c('p', {
    staticClass: "linep"
  }, [_vm._v("请求参数json案例：")]), _vm._v(" "), _c('div', {
    staticClass: "prediv"
  }, [_c('pre', [_vm._v("{\n        \"appKey\":\"\",\n        \"serviceKey\":\"\",\n        \"userKey\":\"\",\n        \"data\":{\n            \"idCard\":\"060017c70edb8ae84bc7f38f723fac0d\",\n            \"phone\":\"db8ece6a58e87adf6bfb9da9719a9b31\",\n            \"name\":\"杨洋\",\n            \"type\":\"type\",\n            \"source\":\"source\"\n        },\n        \"encryptType\":\"md5\"\n    }\n    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "simpleTable"
  }, [_c('p', {
    staticClass: "linep"
  }, [_vm._v("返回参数说明：")]), _vm._v(" "), _c('table', {
    staticClass: "api-table",
    attrs: {
      "border": "0",
      "cellspacing": "0",
      "cellpadding": "0"
    }
  }, [_c('tbody', [_c('tr', {
    staticClass: "title"
  }, [_c('th', {
    attrs: {
      "width": "20"
    }
  }), _vm._v(" "), _c('th', [_vm._v("参数名称")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("上下节点")]), _vm._v(" "), _c('th', [_vm._v("说明")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("status")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("Integer")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("-")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("响应状态码。0成功 1请求成功但没有获取到数据 100失败")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("resultCode")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("String")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("-")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v(" 结束码")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("message")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("String")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("-")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("提示信息")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "simpleTable"
  }, [_c('p', {
    staticClass: "linep"
  }, [_vm._v("JSON返回示例：")]), _vm._v(" "), _c('div', {
    staticClass: "prediv"
  }, [_c('pre', [_vm._v("       /****成功示例**/\n\n            身份证姓名和手机号都匹配\n    {\n      \"status\": 0,\n      \"resultCode\": \"match_data\",\n      \"message\": \"执行成功\",\n      \"currentTime\": 1529982895143,\n      \"data\": {\n        \"result\": 0,\n        \"info\": \"三信息匹配成功\"\n      }\n    }\n\n    身份证和手机号匹配，姓名不匹配\n\n    {\n      \"status\": 0,\n      \"resultCode\": \"match_data\",\n      \"message\": \"执行成功\",\n      \"currentTime\": 1529982926409,\n      \"data\": {\n        \"result\": 101,\n        \"info\": \"手机匹配成功\"\n      }\n    }\n\n    身份证和姓名匹配，手机号不匹配\n\n    {\n      \"status\": 0,\n      \"resultCode\": \"match_data\",\n      \"message\": \"执行成功\",\n      \"currentTime\": 1529982945610,\n      \"data\": {\n        \"result\": 102,\n        \"info\": \"姓名匹配成功\"\n      }\n    }\n\n    能获取到数据，但是手机号和姓名都不匹配\n\n    {\n      \"status\": 0,\n      \"resultCode\": \"match_data\",\n      \"message\": \"执行成功\",\n      \"currentTime\": 1529982960265,\n      \"data\": {\n        \"result\": 103,\n        \"info\": \"信息不匹配\"\n      }\n    }\n\n       /****失败示例**/\n\n    {\n      \"status\": 0,\n      \"resultCode\": \"match_data\",\n      \"message\": \"执行成功\",\n      \"currentTime\": 1529982974899,\n      \"data\": {\n        \"result\": 100,\n        \"info\": \"没有查询到数据\"\n      }\n    }\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "simpleTable"
  }, [_c('p', {
    staticClass: "linep"
  }, [_vm._v("结束码表说明：")]), _vm._v(" "), _c('table', {
    staticClass: "api-table",
    attrs: {
      "border": "0",
      "cellspacing": "0",
      "cellpadding": "0"
    }
  }, [_c('tbody', [_c('tr', {
    staticClass: "title"
  }, [_c('th', {
    attrs: {
      "width": "20"
    }
  }), _vm._v(" "), _c('th', [_vm._v("结束码")]), _vm._v(" "), _c('th', [_vm._v("说明")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("match_data")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("执行成功")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("unmatch_data")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("执行成功,未匹配到数据")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("param_error")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("认证失败，参数错误")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("auth_error")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("认证失败，鉴权未通过")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("system_error")]), _vm._v(" "), _c('td', {
    staticClass: "url"
  }, [_vm._v("执行失败，系统内部错误")])])])])])])])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2c92f280"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/users/Help.vue
// module id = 269
// module chunks = 1